// Butter-coloured "Focus this week" card. Two variants:
//   active — auto-detected pattern surfaced as a Mercury-VP rule
//   cta    — user hasn't set a focus, prompt them to.
// The label is always "Focus this week · auto-detected" in active mode.

import { Link } from "react-router";

type Active = {
  kind: "active";
  headline: string; // "Lead with the recommendation. Save context for after."
  body: string;     // 1-2 sentences, evidence-grounded
  /** Primary CTA. Defaults to "Remind me Wed" linking to /settings if omitted. */
  ctaLabel?: string;
  ctaTo?: string;
  /** Secondary link, e.g. "Pick a different focus". */
  altLabel?: string;
  altTo?: string;
};

type Cta = {
  kind: "cta";
  headline: string;
  body: string;
  ctaLabel: string;
  ctaTo: string;
};

export type FocusTileProps = Active | Cta;

export function FocusTile(props: FocusTileProps) {
  if (props.kind === "active") {
    const { headline, body, ctaLabel = "Remind me", ctaTo = "/settings", altLabel = "Pick a different focus", altTo = "/settings" } = props;
    return (
      <section className="focus-tile">
        <p className="l">Focus this week · auto-detected</p>
        <h2>{headline}</h2>
        <p>{body}</p>
        <div className="focus-tile-cta">
          <Link to={ctaTo} className="btn-pri">
            {ctaLabel}
            <Arrow />
          </Link>
          {altLabel ? (
            <Link to={altTo} className="btn-link">{altLabel}</Link>
          ) : null}
        </div>
      </section>
    );
  }

  return (
    <section className="focus-tile">
      <p className="l">Focus this week</p>
      <h2>{props.headline}</h2>
      <p>{props.body}</p>
      <div className="focus-tile-cta">
        <Link to={props.ctaTo} className="btn-pri">
          {props.ctaLabel}
          <Arrow />
        </Link>
      </div>
    </section>
  );
}

function Arrow() {
  return (
    <svg width={11} height={11} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" aria-hidden="true">
      <path d="M5 12h14M13 5l7 7-7 7" />
    </svg>
  );
}
